module.exports = __webpack_public_path__ + "img/25_BF3_grieve_the_grid.5100269f.jpg";